import { render, staticRenderFns } from "./pdf-viewer.vue?vue&type=template&id=236a4bde&"
import script from "./pdf-viewer.vue?vue&type=script&lang=js&"
export * from "./pdf-viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/pdf-viewer/pdf-viewer.vue
// module id = 274
// module chunks = 1